const json = async (res: Response) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || "Request failed");
  }
  return data;
};

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (init?.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const idem = (init as { idempotencyKey?: string } | undefined)?.idempotencyKey;
  if (idem) headers.set("Idempotency-Key", idem);
  const res = await fetch(`/api/v1${path}`, {
    ...init,
    headers,
    credentials: "include",
  });
  return json(res) as Promise<T>;
}

export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
